import React, { Component } from 'react';
import { string, func, object } from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';
import { lazyLoadWithDimensions } from '../../util/contextHelpers';
import { LINE_ITEM_DAY, LINE_ITEM_NIGHT, propTypes } from '../../util/types';
import { formatMoney } from '../../util/currency';
import { ensureListing, ensureUser } from '../../util/data';
import { richText } from '../../util/richText';
import { createSlug } from '../../util/urlHelpers';
import config from '../../config';
import { NamedLink, ResponsiveImage } from '../../components';

import css from './ListingCard.css';

const MIN_LENGTH_FOR_LONG_WORDS = 10;

const priceData = (price, intl) => {
    if (price && price.currency === config.currency) {
        const formattedPrice = formatMoney(intl, price);
        return { formattedPrice, priceTitle: formattedPrice };
    } else if (price) {
        return {
            formattedPrice: intl.formatMessage(
                { id: 'ListingCard.unsupportedPrice' },
                { currency: price.currency }
            ),
            priceTitle: intl.formatMessage(
                { id: 'ListingCard.unsupportedPriceTitle' },
                { currency: price.currency }
            ),
        };
    }
    return {};
};

class ListingImage extends Component {
    render() {
        return <ResponsiveImage {...this.props} />;
    }
}
const LazyImage = lazyLoadWithDimensions(ListingImage, { loadAfterInitialRendering: 3000 });

export const ListingCardComponent = props => {
    const { className, rootClassName, intl, listing, renderSizes, setActiveListing } = props;
    const classes = classNames(rootClassName || css.root, className);
    const currentListing = ensureListing(listing);
    const id = listing && listing.id;
    const { price } = currentListing.attributes;
    const title = (listing && listing.name) || '';
    const slug = createSlug(title);
    const author = ensureUser(listing.author);
    const authorName = author.attributes.profile.displayName;
    const firstImage = { url: listing.image };
    // currentListing.images && currentListing.images.length > 0 ? currentListing.images[0] : null;

    const { formattedPrice, priceTitle } = priceData(price, intl);

    const unitType = config.bookingUnitType;
    const isNightly = unitType === LINE_ITEM_NIGHT;
    const isDaily = unitType === LINE_ITEM_DAY;

    const unitTranslationKey = isNightly
        ? 'ListingCard.perNight'
        : isDaily
        ? 'ListingCard.perDay'
        : 'ListingCard.perUnit';

    return (
        <NamedLink className={classes} name="ListingPage" params={{ id, slug }}>
            <div
                className={css.threeToTwoWrapper}
                onMouseEnter={() => setActiveListing(currentListing.id)}
                onMouseLeave={() => setActiveListing(null)}
            >
                <div className={css.aspectWrapper}>
                    <img className={css.rootForImage} src={firstImage.url} wi></img>
                </div>
            </div>
            <div className={css.info}>
                <div className={css.mainInfo}>
                    <div className={css.title}>
                        {richText(title, {
                            longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
                            longWordClass: css.longWord,
                        })}
                    </div>
                </div>
            </div>
        </NamedLink>
    );
};

ListingCardComponent.defaultProps = {
    className: null,
    rootClassName: null,
    renderSizes: null,
    setActiveListing: () => null,
};

ListingCardComponent.propTypes = {
    className: string,
    rootClassName: string,
    intl: object.isRequired,
    listing: propTypes.listing.isRequired,

    // Responsive image sizes hint
    renderSizes: string,

    setActiveListing: func,
};

export default injectIntl(ListingCardComponent);
